import { AbstractControl } from '@angular/forms';
import { ValidationResult } from './validation-result';
import * as moment from 'moment';

export class BirthDateValidator {
  static validateAge(control: AbstractControl): ValidationResult {
    const value: moment.Moment = control.value;
    if (value) {
      const age = moment().diff(value, 'years');
      if (age < 18) {
        return { 'invalidAge': true };
      } else if (age > 100) {
        return { 'invalidDate': true }
      }
      else {
        return null;
      }
    } else {
      return null;
    }
  }
};
